import React from "react";
import PortfolioCard from "./PortfolioCard";
import right from "../Assets/Images/right.png";
import left from "../Assets/Images/left.png";

import SelfDirected from "../Assets/Icons/selfdirect.png";
import managed from "../Assets/Icons/managed.png";

const FollowAndTrack = () => {
  return (
    <div className=" w-full max-w-[698px] mt-9 sm:mt-[70px] ">
      <div className=" mb-3 items-center px-[2px] flex justify-between ">
        <div className=" flex gap-[8px] items-center ">
          <div className=" text-[16px] font-[500] text-[#131E3D]  ">
            Follow our wealth tracks
          </div>
          <div className=" flex items-center gap-[6px] ">
            <img
              src={left}
              alt=""
              className="cursor-pointer w-[14px] h-[14px] "
            />
            <img
              src={right}
              alt=""
              className="cursor-pointer w-[14px] h-[14px] "
            />
          </div>
        </div>
      </div>
      <div className="flex-col md:flex-row flex gap-[18px] flex-wrap sm:items-center ">
        <PortfolioCard
          img={SelfDirected}
          // onClick={() => {}}
          main={"Self directed"}
          type={2}
          subtitle={
            "Take control of your investments in our high-value alternative investment campaigns. Select a campaign tailored to your goals and watch your wealth grow"
          }
        />
        <PortfolioCard
          img={managed}
          tag="Coming Soon"
          main={"Managed"}
          type={3}
          subtitle={
            "Let our experts build you a custom portfolio designed to maximize returns, tailored to your financial goals, while you enjoy peace of mind."
          }
        />
      </div>
      <div className="flex gap-2 mt-3 mb-5 px-[2px]">
        <div className="w-[6px] h-[6px] bg-[#192851] rounded-full"></div>
        <div className="w-[6px] h-[6px] bg-[#192851] rounded-full opacity-30"></div>
      </div>
    </div>
  );
};

export default FollowAndTrack;
